<div class="TwoColRouteWrap">
    <router-outlet name="dialog"></router-outlet>
</div>
<ce-layout-two-column-layout />
